import React from 'react';
import EnhancedMarkdown from '../EnhancedMarkdown/EnhancedMarkdown';
import {
  IconDefaultsContextProvider,
  iconSizeExtraLarge,
} from '../../contexts/useIconDefaults';
import BuildsItemBreakdown from '@resources/js/components/BuildsItemBreakdown/BuildsItemBreakdown';
import { EnhancedMarkdownOptionsContextProvider } from '@resources/js/contexts/useEnhancedMarkdownOptions';
import BuildsNoDataPlaceholder from '../BuildsNoDataPlaceholder/BuildsNoDataPlaceholder';
import buildsEnhancedMarkdownOverrides from '@resources/js/helpers/buildsEnhancedMarkdownOverrides';

export type BuildsBestEnchantsViewModel = {
  title: string;
  description: string;
  itemLabel: string;
  popularityLabel: string;
  itemBreakdowns: BuildsItemBreakdownViewModel[];
};

export type BuildsItemBreakdownViewModel = {
  slotLabel: string;
  bestLabel: string | null;
  itemMarkdown: string;
  iconMarkdown: string;
  popularityMarkdown: string;
  rtl: boolean;
};

export default function BuildsBestEnchantsSection({
  title,
  description,
  itemLabel,
  popularityLabel,
  itemBreakdowns,
}: BuildsBestEnchantsViewModel): JSX.Element {
  return (
    <EnhancedMarkdownOptionsContextProvider value={{ lazyLoad: false }}>
      <div className='builds-best-enchants-section'>
        <EnhancedMarkdown
          markdown={`
# ${title}

${description}
`}
          overrides={buildsEnhancedMarkdownOverrides}
        />
        {itemBreakdowns.length > 0 ? (
          <IconDefaultsContextProvider
            overrides={{
              icon: {
                size: iconSizeExtraLarge,
                rounded: false,
                bordered: true,
              },
              item: { size: 20 },
              ability: { size: 20 },
            }}
          >
            <div className='builds-best-enchants-section__header'>
              <div className='builds-best-enchants-section__header-section builds-best-enchants-section__header-section--left'>
                <div className={'builds-best-enchants-section__header-column'}>
                  {itemLabel}
                </div>
                <div className={'builds-best-enchants-section__header-column'}>
                  {popularityLabel}
                </div>
              </div>
              <div className='builds-best-enchants-section__header-section builds-best-enchants-section__header-section--right'>
                <div className={'builds-best-enchants-section__header-column'}>
                  {popularityLabel}
                </div>
                <div className={'builds-best-enchants-section__header-column'}>
                  {itemLabel}
                </div>
              </div>
            </div>
            <div className='builds-best-enchants-section__group'>
              {itemBreakdowns.map((itemBreakdown, index) => {
                return (
                  <div
                    key={index}
                    className={'builds-best-enchants-section__item'}
                  >
                    {itemBreakdown && (
                      <BuildsItemBreakdown
                        key={index}
                        {...itemBreakdown}
                        side={index % 2 === 0 ? 'left' : 'right'}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </IconDefaultsContextProvider>
        ) : (
          <BuildsNoDataPlaceholder marginTop={1} />
        )}
      </div>
    </EnhancedMarkdownOptionsContextProvider>
  );
}
